export default __webpack_public_path__ + "static/media/08.3477a765.png";